import { PREFIX } from '../../constants';

const generateBackgroundAttributes = ({ controlName }) => {
    return {
        [`${PREFIX}${controlName}bgType`]: {
            type: 'string',
            default: 'classic'
        },
        [`${PREFIX}${controlName}bgColor`]: {
            type: 'string'
        },
        [`${PREFIX}${controlName}bgGradient`]: {
            type: 'string'
        },
        [`${PREFIX}${controlName}bgImage`]: {
            type: 'object',
            default: {
                id: '',
                url: ''
            }
        },
        [`${PREFIX}${controlName}bgImageSize`]: {
            type: 'string',
            default: 'cover'
        },
        [`${PREFIX}${controlName}bgImagePosition`]: {
            type: 'string',
            default: 'center center'
        },
        [`${PREFIX}${controlName}bgImageAttachment`]: {
            type: 'string',
            default: 'scroll'
        },
        [`${PREFIX}${controlName}bgImageRepeat`]: {
            type: 'string',
            default: 'no-repeat'
        },
        [`${PREFIX}${controlName}bgImageOverlay`]: {
            type: 'boolean',
            default: false
        },
        [`${PREFIX}${controlName}bgImageOverlayColor`]: {
            type: 'string'
        },
        [`${PREFIX}${controlName}bgImageOverlayOpacity`]: {
            type: 'number',
            default: 0.5
        }
    };
};

export default generateBackgroundAttributes;
